import axios from 'axios';
import { setAlert } from "./alert";

import { url } from '../utils/api';
import { ADD_COUPON, COUPON_ERROR, DELETE_COUPON, GET_COUPONS } from './types';

// Get coupons
export const getCoupons = () => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.get(`${url}/api/coupons`, config);
  
          dispatch({
              type: GET_COUPONS,
              payload: res.data
          });
      } catch (err) {
          dispatch({
              type: COUPON_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
      }
  }
  
// Add coupon
export const addCoupon = (formData, navigate) => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.post(`${url}/api/coupons/add`, formData, config);
  
          dispatch({
              type: ADD_COUPON,
              payload: res.data
          });
  
          dispatch(setAlert('Added a new coupon', 'success'));
          navigate('/adminDashboard/coupons');
      } catch (err) {
          dispatch(setAlert('This coupon code already exists', 'danger'));
          dispatch({
              type: COUPON_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
          
      }
}

// Delete Coupon
export const deleteCoupon = (_id, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if(window.confirm('Are you sure about deleting this coupon? This can NOT be undone!')) {
        try {
            await axios.delete(`${url}/api/coupons/${_id}`, config);

            dispatch({
                type: DELETE_COUPON,
                payload: _id
            });
            navigate('/adminDashboard/coupons');
            dispatch(setAlert('Coupon Deleted', 'success'));
        } catch (err) {
            dispatch({
                type: COUPON_ERROR,
                payload: { msg: err.response.statusText, status: err.response.status}
            });
        }
    }
};
